import {  Loader } from '@fluentui/react-northstar';
import { authentication } from '@microsoft/teams-js';

// A wrapper for <Route> that redirects to the login screen if you're not yet authenticated.
// eslint-disable-next-line react/prop-types
const LoginEndRoute = () => {

  authentication.notifySuccess('ok');
  
  return (
    <Loader />);
};

export default LoginEndRoute;
